<script>
    import FilterItemEditHeader from '@/components/page-filter-edit/filter-item-edit/FilterItemEditHeader.vue';
    import FilterItemEditData from '@/components/page-filter-edit/filter-item-edit/FilterItemEditData.vue';
    import FilterItemParentFilter from '@/components/page-filter-edit/FilterItemParentFilter.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_FILTER_ITEM_EDIT}
        },
        components: {
            FilterItemEditHeader: FilterItemEditHeader,
            FilterItemEditData: FilterItemEditData,
            FilterItemParentFilter: FilterItemParentFilter,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <FilterItemEditHeader />
        <hr class="hr_light_98">
        <FilterItemEditData />
        <hr class="hr_light_98">
        <FilterItemParentFilter 
            :storeData="$store.getters.FILTER_ITEM_DATA_EDIT"
        />
    </div>
</template>